var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',_vm._l((_vm.otherLocales),function(l){return _c('a',{key:l,staticClass:"px-4 py-2 hover:bg-menu-hover block",attrs:{"href":_vm.nextRoute(l)},domProps:{"textContent":_vm._s(_vm.i18n[l].nextRoute)}})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }